export const SIDEBAR_STATE = 'SIDEBAR_STATE';
